/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Unit
 * @export
 * @interface SAPUnit
 */
export interface SAPUnit {
    /**
     * Code of the unit
     * @type {string}
     * @memberof SAPUnit
     */
    code?: string;
    /**
     * Name of the unit
     * @type {string}
     * @memberof SAPUnit
     */
    name?: string;
    /**
     * Code of the unit is used to check availability, which can be retrieved either from 'code' without any integration, from 'sapCode' with SAP OMSA integration, or potentially from another source through custom integration with a stock service.
     * @type {string}
     * @memberof SAPUnit
     */
    availabilityCode?: string;
    /**
     * Code of the SAP unit
     * @type {string}
     * @memberof SAPUnit
     */
    sapCode?: string;
}

/**
 * Check if a given object implements the SAPUnit interface.
 */
export function instanceOfSAPUnit(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPUnitFromJSON(json: any): SAPUnit {
    return SAPUnitFromJSONTyped(json, false);
}

export function SAPUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'availabilityCode': !exists(json, 'availabilityCode') ? undefined : json['availabilityCode'],
        'sapCode': !exists(json, 'sapCode') ? undefined : json['sapCode'],
    };
}

export function SAPUnitToJSON(value?: SAPUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'availabilityCode': value.availabilityCode,
        'sapCode': value.sapCode,
    };
}

